var map = {
	"./da": 82453,
	"./da.js": 82453,
	"./fr": 27390,
	"./fr-ca": 66711,
	"./fr-ca.js": 66711,
	"./fr-ch": 6152,
	"./fr-ch.js": 6152,
	"./fr.js": 27390,
	"./nl": 20600,
	"./nl-be": 78796,
	"./nl-be.js": 78796,
	"./nl.js": 20600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28971;